import * as spritejs from 'spritejs';
import { draggable } from 'next-draggable'
const { Sprite, Group } = spritejs;
export class ResizeBlock extends Group {
    constructor(options = { pos: [0, 0], size: [100, 30], backgroundColor: '#eee', borderColor: '#f00', borderWidth: 1, dragRect: [], id: "" }) {
        super()
        this.size = options.size || [100, 30]
        this.backgroundColor = options.backgroundColor||'#eee'
        this.borderWidth = options.borderWidth||1
        this.borderColor = options.borderColor||'#f00'
        this.dragRect = options.dragRect ||[]
        this.id = options.id || ''
        this.attr({...options, clipOverflow: false, pos: options.pos||[0,0] })
        this.init()
    }
    init() {
        let dragPx = 16 //拖动块的大小
        let offset = 10;
        let $drag = new Sprite({
            texture: 'images/scale.png',
        })

        draggable(this, { dragRect: this.dragRect })
        draggable($drag, { dragRect: [dragPx * 2, dragPx * 2] }) //父级容器至少为拖动块的两倍大小
        let $group = this
        $group.attr({ size: this.size })
        $drag.attr({ anchor: [1, 1], size: [dragPx, dragPx], pos: [this.size[0] + offset, this.size[1] + offset], opacity: 0, pointerEvents: 'none' })
        $drag.addEventListener('drag', function (evt) {
            let [x, y] = this.attr('pos')
            $group.attr({ size: [x - offset, y - offset] })
            $group.setChildScale(x - offset * 2, y - offset * 2)
        })
        $drag.addEventListener('dragend', function () { })
        $drag
            .addEventListener('mouseenter', function () {
                
                if (this.layer&& this.layer.canvas) {
                    this.layer.canvas.style.cursor = 'se-resize'
                }
            })
            .addEventListener('mouseleave', function () {
                if (this.layer&& this.layer.canvas) {
                    this.layer.canvas.style.cursor = 'default'
                }
            })
        this.append($drag)

        this.addEventListener('mouseenter', (e) => {
            e.stopPropagation();
            $group.attr({
                border: [this.borderWidth, this.borderColor],
                bgcolor: this.backgroundColor
            })
            $drag.attr({ opacity: 1, pointerEvents: 'visible' })
        })
        this.addEventListener('mouseleave', (e) => {
            e.stopPropagation();
            $group.attr({
                border: [0, 'transparent'],
                bgcolor: 'transparent'
            })
            $drag.attr({ opacity: 0, pointerEvents: 'none' })
        })
        this.contextMenu()
    }

    contextMenu(e) {
        this.addEventListener('contextmenu', (e) => {
            e.stopPropagation();
        })
    }

    setChildScale(x, y) {
        let child = this.children;
        for (let i = 0; i < child.length; i++) {
            if (child[i].cname === 'sprite') {
                child[i].attr({
                    size: [x, y]
                })
            }
        }
    }
}